import {useEffect, useRef, useState} from 'react';
import {useApi} from '../../Providers/ApiProvider/ApiProvider';

export const useConnectPlatformTransparency = () => {
  const {fetchConnectPlatformTransparency} = useApi();
  const ref = useRef<boolean>(false);
  const [platformName, setPlatformName] = useState<string>();
  const [showSharingNotice, setShowSharingNotice] = useState<boolean>();

  useEffect(() => {
    if (!ref.current) {
      ref.current = true;

      fetchConnectPlatformTransparency().then((result) => {
        if (result.type === 'success') {
          setPlatformName(result.platformName);
          setShowSharingNotice(result.showSharingNotice);
        }
      });
    }
  }, [fetchConnectPlatformTransparency]);

  return {platformName, showSharingNotice};
};
